// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NxnLAoe4MeQzKS8YFPHw {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 16px 0;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/AppointmentBooking/components/Register/Register.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB","sourcesContent":[".wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 16px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `NxnLAoe4MeQzKS8YFPHw`
};
export default ___CSS_LOADER_EXPORT___;
